"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFocusChange = void 0;
const gamepadEvents_1 = require("../../core/gamepadEvents");
const createUseSubscriptionHandler_1 = require("../inner-utility/createUseSubscriptionHandler");
/**
 * Fires given handlers when the focus changes to another element.
 *
 * @param handler - the handler when focus shifts between elements (previousFocus to nextFocus).
 * Return true to prevent this from propagating further up the tree.
 */
exports.useFocusChange = (0, createUseSubscriptionHandler_1.createUseSubscriptionHandler)(gamepadEvents_1.NavigationEvent.Change);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlRm9jdXNDaGFuZ2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvaG9va3MvbmF2aWdhdGlvbi91c2VGb2N1c0NoYW5nZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsNERBQTREOzs7QUFFNUQsNERBQTJEO0FBRTNELGdHQUE2RjtBQUU3Rjs7Ozs7R0FLRztBQUNVLFFBQUEsY0FBYyxHQUFHLElBQUEsMkRBQTRCLEVBRXhELCtCQUFlLENBQUMsTUFBTSxDQUFDLENBQUMifQ==